import { render, staticRenderFns } from "./RedeemCard.vue?vue&type=template&id=5595175b&scoped=true"
import script from "./RedeemCard.vue?vue&type=script&lang=js"
export * from "./RedeemCard.vue?vue&type=script&lang=js"
import style0 from "./RedeemCard.vue?vue&type=style&index=0&id=5595175b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5595175b",
  null
  
)

export default component.exports